module.exports = __webpack_public_path__ + "img/price-balance.d337ef9c.webp";